import React, { createContext, useState, useContext } from "react";

import { SurveyContext } from "./survey";
import { SurveyNavigationContext } from "./survey-navigation";
import { SurveyQuestionsVisibilityContext } from "./survey-questions-visibility";

import * as ValidInput from "../utils/survey/valid-input";

export const SurveyValidInputContext = createContext();

const SurveyValidInputProvider = ({ children }) => {
  const { questionnaire, answers } = useContext(SurveyContext);
  const { questionsVisibility } = useContext(SurveyQuestionsVisibilityContext);
  const { visibleDimensions } = useContext(SurveyNavigationContext);

  const [wasValidated, setWasValidated] = useState(false);
  const [validInput, setValidInput] = useState(undefined);

  const firstInvalidQuestion = ValidInput.updateFirstInvalidQuestion(
    validInput,
    questionsVisibility
  );
  const isAllInputValid = ValidInput.isAllInputValid(validInput, questionsVisibility);

  const updateValidInput = () => {
    setWasValidated(true);
    setValidInput({
      ...ValidInput.getValidInput(questionnaire, answers, visibleDimensions),
    });
  };

  const resetValidInput = () => {
    setWasValidated(false);
    setValidInput(undefined);
  };

  return (
    <SurveyValidInputContext.Provider
      value={{
        wasValidated,
        validInput,
        firstInvalidQuestion,
        isAllInputValid,
        updateValidInput,
        resetValidInput,
      }}
    >
      {children}
    </SurveyValidInputContext.Provider>
  );
};

export default SurveyValidInputProvider;
